import React from "react";
import styled from "styled-components";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import TickIcon from "../../assets/img/icons/tick.svg";

const StatusColorAndText = {
  "in progress": {
    bgColor: "#F0ECFA",
    textColor: "#6C2EF2",
    text: "In Progress",
  },
  completed: {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Completed",
  },
  missed: {
    bgColor: "#FFE4E4",
    textColor: "#FE2424",
    text: "Missed",
  },
  "to do": {
    bgColor: "#E6EEFD",
    textColor: "#2266EF",
    text: "To Do",
  },
  "ready to dispatch": {
    bgColor: "#2266EF",
    textColor: "#FFFFFF",
    text: "Ready to Dispatch",
  },
  "partially complete": {
    bgColor: "#FFA500",
    textColor: "#FFFFFF",
    text: "Partially Complete",
  },

  "totally missed": {
    bgColor: "#EB5757",
    textColor: "#FFFFFF",
    text: "Totally Missed",
  },
  late: {
    bgColor: "#EB5757",
    textColor: "#FFFFFF",
    text: "Late",
  },
  scheduled: {
    bgColor: "#2266EF",
    textColor: "#FFFFFF",
    text: "Scheduled",
  },
  unscheduled: {
    bgColor: "#A0A0A0",
    textColor: "#FFFFFF",
    text: "Unscheduled",
  },

  approved: {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Approved",
  },
  pending: {
    bgColor: "#FCEECA",
    textColor: "#BF8D03",
    text: "Pending",
  },
  rejected: {
    bgColor: "#FFE4E4",
    textColor: "#FE2424",
    text: "Rejected",
  },
  done: {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Done",
  },
  "not done": {
    bgColor: "#FFE4E4",
    textColor: "#DDF4E5",
    text: "Not Done",
  },
  "open": {
    bgColor: "#A0A0A0",
    textColor: "#FFFFFF",
    text: "Open",
  },
  "in_progress": {
    bgColor: "#F0ECFA",
    textColor: "#6C2EF2",
    text: "In Progress",
  },
  "complete": {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Complete",
  },
  "completed": {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Completed",
  },
  "high": {
    bgColor: "#FFE4E4",
    textColor: "#FE2424",
    text: "High",
  },
  "medium": {
     bgColor: "#F0ECFA",
    textColor: "#6C2EF2",
    text: "Medium",
  },
  "low": {
    bgColor: "#DDF4E5",
    textColor: "#039935",
    text: "Low",
  },
  "no": {
   bgColor: "#F5F0EC",
    textColor: "#9C7B67",
    text: "No",
  },
  "not_added": {
    bgColor: "#F5F0EC",
    textColor: "#9C7B67",
    text: "Not Added",
  },
  "added": {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Added",
  },
  mina:{
    bgColor: "#F0FDFA",
    textColor: "#0D9488",
    text: "Mina",
  },
  arafat:{
    bgColor: "#FFFBEB",
    textColor: "#D97706",
    text: "Arafat",
  },
  muzdalifah:{
    bgColor: "#f7f3f6",
    textColor: "#fc38f3",
    text: "Muzdalifah",
  },
  "completed 25": {
    bgColor: "#FEE8D5",
    textColor: "#C05621",
    text: "Completed 25%",
  },
  "completed 50": {
    bgColor: "#CFFAFE",
    textColor: "#0E7490",
    text: "Completed 50%",
  },
  "completed 75": {
    bgColor: "#ECFCCB",
    textColor: "#4D7C0F",
    text: "Completed 75%",
  },
  "completed 100": {
    bgColor: "#BBF7D0",
    textColor: "#065F46",
    text: "Completed 100%",
  },
  "not completed": {
    bgColor: "#FDE8EF",
    textColor: "#BE185D",
    text: "Not Completed",
  },
  "not_completed": {
    bgColor: "#FDE8EF",
    textColor: "#BE185D",
    text: "Not Completed",
  },
  "0": {
    bgColor: "transparent",
    textColor: "#000000",
    text: "0",
  },
};

const StatusDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ textColor }) => textColor || "#FFFFFF"};
  margin-right: 6px;
`;

const StatusTick = styled.div`
  width: 16px;
  height: 16px;
  background-image: url(${TickIcon});
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 6px;
`;

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px 5px 10px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 12px;
  background-color: ${({ status }) => {
    if (!status) return "#A0A0A0";
    const normalizedStatus = status.toLowerCase();
    return StatusColorAndText[normalizedStatus]?.bgColor || "#A0A0A0";
  }};
  color: ${({ status }) => {
    if (!status) return "#FFFFFF";
    const normalizedStatus = status.toLowerCase();
    return StatusColorAndText[normalizedStatus]?.textColor || "#FFFFFF";
  }};
  width: max-content;
`;

const Status = ({ status, showDot = false, showTickIcon = false }) => {
  if (!status) {
    return '-';
  }

  const normalizedStatus = status.toLowerCase();
  const statusConfig = StatusColorAndText[normalizedStatus];
  const displayText = statusConfig?.text || status;
  const textColor = statusConfig?.textColor || "#FFFFFF";

  return (
    <StatusContainer status={normalizedStatus}>
      {showDot && <StatusDot textColor={textColor} />}
      {showTickIcon && <StatusTick textColor={textColor} />} 
      {displayText}
    </StatusContainer>
  );
};

export default Status;
